<div class="wrapper">
  <div class="chevron" [class.chevron--is-focused]="isActive">
    <int-icon name="chevron" size="0.9rem"></int-icon>
  </div>
</div>
